import { render, staticRenderFns } from "./AddressDataForm.vue?vue&type=template&id=0b371b2b&scoped=true&"
import script from "./AddressDataForm.vue?vue&type=script&lang=js&"
export * from "./AddressDataForm.vue?vue&type=script&lang=js&"
import style0 from "./AddressDataForm.vue?vue&type=style&index=0&id=0b371b2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b371b2b",
  null
  
)

export default component.exports